import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import CustomersRepository from "@/core/customers/repositories/CustomersRepository";
import { CustomersResponse } from "@/core/customers/entities/Customers";

export default class SearchCoreBankingCustomersUseCase {
  constructor(private readonly customersRepository: CustomersRepository) {}

  async execute(accountNumber: string): Promise<CustomersResponse> {
    try {
      return await this.customersRepository.searchCoreBanking(accountNumber);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      }
      const error = new Error("Core banking search failed") as Error &
        Exception<unknown, DefaultExceptionTypes>;
      error.type = DefaultExceptionTypes.UNKNOWN_ERROR;
      error.body = e;
      throw error;
    }
  }
}
